export const IssueStatuses = [
  "Under investigation",
  "Under review",
  "In progress",
  "Waiting for support",
]

export const IssueSystems = [
  "Junifer (all)",
  "Website - customer facing",
  "Spark",
  "Junifer Payments",
  "Junifer Billing",
  "Fresh Desk",
  "Fresh chat",
]
